import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import palette from './palette';
import typography from './typography';
import components from './components';

// Create the base theme
let theme = createTheme({
  palette,
  typography,
  components,
  shape: {
    borderRadius: 6,
  },
  shadows: [
    'none',
    '0px 0px 10px rgba(0,0,0,0.1)',
    '0px 2px 10px rgba(0,0,0,0.1)',
    '0px 3px 10px rgba(0,0,0,0.1)',
    '0px 4px 10px rgba(0,0,0,0.1)',
    '0px 5px 10px rgba(0,0,0,0.1)',
    '0px 6px 10px rgba(0,0,0,0.1)',
    '0px 7px 10px rgba(0,0,0,0.1)',
    '0px 8px 10px rgba(0,0,0,0.1)',
    '0px 9px 10px rgba(0,0,0,0.1)',
    '0px 10px 10px rgba(0,0,0,0.1)',
    '0px 11px 10px rgba(0,0,0,0.1)',
    '0px 12px 10px rgba(0,0,0,0.1)',
    '0px 13px 10px rgba(0,0,0,0.1)',
    '0px 14px 10px rgba(0,0,0,0.1)',
    '0px 15px 10px rgba(0,0,0,0.1)',
    '0px 16px 10px rgba(0,0,0,0.1)',
    '0px 17px 10px rgba(0,0,0,0.1)',
    '0px 18px 10px rgba(0,0,0,0.1)',
    '0px 19px 10px rgba(0,0,0,0.1)',
    '0px 20px 10px rgba(0,0,0,0.1)',
    '0px 21px 10px rgba(0,0,0,0.1)',
    '0px 22px 10px rgba(0,0,0,0.1)',
    '0px 23px 10px rgba(0,0,0,0.1)',
    '0px 24px 10px rgba(0,0,0,0.1)',
  ],
  spacing: 8,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
});

// Apply responsive typography
theme = responsiveFontSizes(theme);

export default theme;